<div class="dialog-head" [ngClass]="{ 'dialog-head-rtl': !selectedLanguage.IsLeftToRight }">
  <h3 class="m-0">{{ title }}</h3>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="respone(null)">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content [ngClass]="{ 'mat-dialog-content-rtl': !selectedLanguage.IsLeftToRight }">
  <p class="my-3 body" [innerHTML]="body" [title]="body"></p>
  <div *ngIf="warning" class="warning-div">
    <div class="warning-head">
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.109 15.5L11.4423 3.83332C11.297 3.57682 11.0862 3.36347 10.8314 3.21504C10.5767 3.06661 10.2872 2.9884 9.99234 2.9884C9.69752 2.9884 9.40797 3.06661 9.15324 3.21504C8.8985 3.36347 8.6877 3.57682 8.54234 3.83332L1.87567 15.5C1.72874 15.7544 1.6517 16.0432 1.65235 16.3371C1.653 16.6309 1.73132 16.9194 1.87938 17.1732C2.02744 17.427 2.23996 17.6371 2.49542 17.7823C2.75088 17.9275 3.04018 18.0026 3.33401 18H16.6673C16.9598 17.9997 17.2469 17.9225 17.5001 17.7761C17.7532 17.6297 17.9634 17.4192 18.1094 17.1659C18.2555 16.9126 18.3324 16.6253 18.3323 16.3329C18.3322 16.0405 18.2552 15.7532 18.109 15.5Z"
          stroke="#E92E2E"
          stroke-width="1.71746"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 8V11.3333"
          stroke="#E92E2E"
          stroke-width="1.71746"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 14.6667H10.0083"
          stroke="#E92E2E"
          stroke-width="1.71746"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p class="main-text">{{ 'COMMON.warning' | translate }}</p>
    </div>
    <p class="text" [innerHTML]="warning" [title]="warning"></p>
  </div>
  <div class="row justify-content-end align-items-center gap-1" [ngClass]="{ 'margin-zero': !selectedLanguage.IsLeftToRight }">
    <button class="primary-btn" (click)="respone(true)" *ngIf="okButtonName">
      {{ okButtonName }}
    </button>
    <button class="secondary-btn" (click)="respone(false)" *ngIf="cancelButtonName">
      {{ cancelButtonName }}
    </button>
  </div>
</div>
